'use client';

import 'material-symbols/rounded.css';
import dynamic from 'next/dynamic';
import { usePathname } from 'next/navigation';
import cx from 'classnames';

const Navigation = dynamic(() => import('@/main/app/components/navigation'), { ssr: false });
const SettingsNavigation = dynamic(() => import('@/main/app/components/settings-navigation'), { ssr: false });

export default function AppLayout({
  children,
}: {
  children: React.ReactNode;
}) {
  const pathname = usePathname();

  const isSettings = pathname.startsWith('/account');
  const isOnboarding = pathname.startsWith('/setup');
  const isBilling = pathname.startsWith('/billing');
  const isEditor = pathname.startsWith('/account/embeds/') || pathname.startsWith('/account/pages/customize');
  const isChangePlan = pathname === '/account/billing/change-plan';
  
  const isMainNavVisible = !isSettings && !isOnboarding && !isBilling && !isEditor && !isChangePlan;
  
  const className = cx(
    'flex flex-col w-auto flex-1 mt-12 md:mt-0',
    (isMainNavVisible || (isSettings && !isChangePlan)) && !isEditor ? 'md:ml-52' : ''
  );

  return (
    <div className={cx('min-h-screen bg-white', (!isMainNavVisible || isChangePlan) && 'flex')}>
      {isSettings && !isEditor && !isChangePlan && <SettingsNavigation />}
      {isMainNavVisible && <Navigation />}
      <div className={className}>
        {children}
      </div>
    </div>
  );
}
